import {
  LOADED_LEAD,
  LOADED_INITIAL_INFO,
  SET_MAGIC_LINK,
  UPDATE_CURRENT_LEAD,
  ADD_CART_ITEM,
  UPDATED_LEAD,
  RELOAD_LEAD_FILES,
  UPLOAD_ICP_FILE,
  REMOVE_FROM_ICP_FILES,
  SEND_CONFIRMATION_FINISHED,
  SHOW_CONFIRMATION_SCREEN,
  SHOW_HIDE_FILLED,
  UPDATE_LEAD_ID,
  REDIRECT_TO_WEBSHOP,
  REDIRECT_TO_WEBSHOP_STARTED,
  REDIRECT_TO_WEBSHOP_ENDED,
  SELECT_STEP,
  GOOGLE_ADDRESS,
  IS_VALID_VAT,
  VALIDATING_VAT,
  UPDATE_FLOW,
  UPDATE_ICP_CART,
  UPDATE_NEXT_FLOW,
  SET_COMPANY_TYPE,
  CLICKEDCONTINUE_FLOW,
} from "../action/types";

import _ from "lodash";

const DEFAULT_CART_ITEM = {
  isRepeating: null,
  materialImages: [],
  materialDocuments: [],
  isTargetPrice: null,
  randomId: "1",
  quantityUnit: null,

  targetPriceCurrency: "EUR",
};

const INITIAL_STATE = {
  lead: {
    ICPCart: [{ ...DEFAULT_CART_ITEM }],
    cart: [{ ...DEFAULT_CART_ITEM, randomId: Date.now() }], // use date.now for unique id
    trackingInfo: {},
    urgency: "99",
  },
  magicLinkToken: null,
  initialInfo: {
    loadingCapabilities: [],
    transports: [],
    companyTypes: [],
  },
  companyType: "",
  flow: "start",
  nextFlow: "pro",
  clickedContinue_flow: null,
  files: [],
  icpfiles: [],
  loadedFromToken: false,
  finished: false,
  hideFilled: false,
  redirectToWebshop: false,
  redirectToWebshopCheked: false,
  selectedStep: "section_0",
  isValidVat: null,
  isValidatingVat: false,
  subscribeToNewsletter: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOADED_LEAD:
      if ("" !== action.payload) {
        return {
          ...state,
          lead: action.payload,
          loadedFromToken: true,
          isValidVat: true,
        };
      }
      return { ...state };
    case LOADED_INITIAL_INFO:
      return { ...state, initialInfo: transformInitialData(action.payload) };
    case SET_MAGIC_LINK:
      return { ...state, magicLinkToken: action.payload };
    case CLICKEDCONTINUE_FLOW:
      return { ...state, clickedContinue_flow: action.payload };

    case SET_COMPANY_TYPE:
      return { ...state, companyType: action.companyType };

    case UPDATE_NEXT_FLOW:
      return { ...state, nextFlow: action.flow };
    case UPDATE_FLOW:
      return { ...state, flow: state.nextFlow };
    case UPDATE_ICP_CART:
      let oldLead = { ...state.lead };
      oldLead.ICPCart = action.icpCart;
      return { ...state, lead: oldLead };
    case UPDATED_LEAD:
      return { ...state, lead: action.payload };
    case UPDATE_CURRENT_LEAD:
      let newlead = { ...state.lead };
      newlead[action.payload.field] = action.payload.value;
      return { ...state, lead: newlead };
    case UPDATE_LEAD_ID:
      let currentLead = { ...state.lead };
      currentLead.leadId = action.leadId;
      return { ...state, lead: currentLead };
    case ADD_CART_ITEM:
      let newleadCart = { ...state.lead };
      let newItem = { ...DEFAULT_CART_ITEM, randomId: Date.now() };
      newItem.materialImages = [];
      newItem.materialDocuments = [];
      newleadCart.cart.push(newItem);
      return { ...state, lead: newleadCart };
    case RELOAD_LEAD_FILES:
      return { ...state, files: action.payload };
    case UPLOAD_ICP_FILE:
      return { ...state, icpfiles: [...state.icpfiles, action.payload] };
    case REMOVE_FROM_ICP_FILES:
      const newState = JSON.parse(JSON.stringify(state));
      newState.icpfiles = state.icpfiles.filter(
        (file) => file._id !== action.payload
      );
      return newState;
    case SEND_CONFIRMATION_FINISHED:
      return { ...state, finished: true };
    case SHOW_CONFIRMATION_SCREEN:
      return { ...state, confirm: true };
    case GOOGLE_ADDRESS:
      return { ...state, addressOptions: action.arrAddress };
    case SHOW_HIDE_FILLED:
      return { ...state, hideFilled: action.payload };
    case REDIRECT_TO_WEBSHOP_STARTED:
      return {
        ...state,
        redirectToWebshopCheked: false,
      };
    case REDIRECT_TO_WEBSHOP_ENDED:
      return {
        ...state,
        redirectToWebshopCheked: true,
      };
    case REDIRECT_TO_WEBSHOP:
      return {
        ...state,
        redirectToWebshop: true,
      };
    case SELECT_STEP:
      return { ...state, selectedStep: action.payload };
    case VALIDATING_VAT:
      return { ...state, isValidatingVat: true };
    case IS_VALID_VAT:
      if (action.payload) {
        const { isKnownCountry, isValid } = action.payload;
        // If the VAT is from an unknown country let the user go
        let isValidVat = isValid || !isKnownCountry;
        return { ...state, isValidVat, isValidatingVat: false };
      } else {
        return {
          ...state,
          isValidVat: false,
          isValidatingVat: false,
        };
      }
    default:
      return state;
  }
};

// Transfor initial data
function transformInitialData(data) {
  // Products
  let products = [];
  data.products.map((p) => {
    let product = {
      label: p.name,
      value: p.value,
      materialId: p.value,
      disabled: p.isCategory,
      aliasId: p.aliasId,
    };
    products.push(product);
  });
  data.products = products;

  // Transports
  let transports = [];
  data.transports.map((t) => {
    let transport = { label: t._id, value: t._id };
    transports.push(transport);
  });
  data.transports = transports;

  // Countries
  let countries = [];
  data.countries.map((c) => {
    let country = { label: c.name, value: c.code };
    countries.push(country);
  });
  data.countries = _.orderBy(countries, ["label"], ["asc"]);

  // Storage types
  let storageTypes = [];
  data.storageTypes.map((t) => {
    let type = { label: t.name, value: t.value, parent: t.parent };
    storageTypes.push(type);
  });
  data.storageTypes = storageTypes;

  // Company tax types
  let companyTaxTypes = [];
  data.companyTaxTypes.map((t) => {
    let type = { label: t.name, value: t.value };
    companyTaxTypes.push(type);
  });
  data.companyTaxTypes = companyTaxTypes;

  // Company types
  let companyTypes = [];
  const companyTypesOrder = [
    "industry",
    "company",
    "scrap dealers",
    "private",
    "consumer",
  ];
  data.companyTypes.map((t) => {
    let type = {
      label: t.fieldName,
      value: t.fieldName,
      sortIndex: companyTypesOrder.indexOf(t.fieldName),
    };
    companyTypes.push(type);
  });

  // Order should be (industry, company, scrap dealers, private, consumer)
  data.companyTypes = _.orderBy(companyTypes, ["sortIndex"], ["asc"]);

  // Hear about types
  let hearAboutTypes = [];
  data.hearAboutTypes.map((t) => {
    let type = {
      label: t.fieldName,
      value: t.fieldName,
      needsDescription: t.needsDescription,
      descriptionText: t.descriptionText,
    };
    hearAboutTypes.push(type);
  });
  data.hearAboutTypes = _.orderBy(hearAboutTypes, ["label"], ["asc"]);

  return data;
}
